export const EMPTY_DIV = 'empty-div';
export const WRAPPER = 'wrapper';
export const RIGHT_CONTAINER = 'right-container';
export const TARA_LOGO = 'tara-logo';
export const STEP_INDICATOR = 'step-indicator';
export const STEP_INDICATOR_DOT = 'step-indicator-dot-';
